import { useContext } from "react";
import { GeolocationContext } from "./GeolocationContext";

export function useGeolocationContext() {
    return useContext(GeolocationContext);
}
